import React from "react";
import styled from "styled-components";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import {
  FilterButtonList,
  FilterDropdownContent,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { setFilters, unsetFilters } from "tasks/actions";
import {
  ItemDetails,
  PRIORITY_ITEMS,
  PriorityBadge,
} from "tasks/components/PriorityBadge";
import { useStore as useTasksStore } from "tasks/store";

const StyledFilterDropdownContent = styled(FilterDropdownContent)`
  max-width: 3rem;
`;

export const PriorityFilters = () => {
  const { state: tasksState, dispatch } = useTasksStore();
  const {
    filters: { priority },
  } = tasksState;

  const selectedPriorities = priority || [];
  const totalSelected = selectedPriorities.length;

  const renderPriorityItem = (item: ItemDetails) => {
    const { value } = item;
    if (!value) {
      return null;
    }

    const checked = selectedPriorities.includes(value);
    const filter = {
      priority: [value],
    };
    const onClick = () => {
      if (checked) {
        dispatch(unsetFilters(filter));
      } else {
        dispatch(setFilters(filter));
      }
    };

    return (
      <CheckboxDropdownItem checked={checked} onClick={onClick}>
        <PriorityBadge priority={value} />
      </CheckboxDropdownItem>
    );
  };

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Priority
          {totalSelected > 0 && ` (${totalSelected})`}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen }) =>
        isPortalOpen && (
          <StyledFilterDropdownContent align="center">
            <FilterButtonList>
              {PRIORITY_ITEMS.map(renderPriorityItem)}
            </FilterButtonList>
          </StyledFilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
